// extracted by mini-css-extract-plugin
module.exports = {"recentlyViewedDesktopCarousel":"RecentlyViewedRentals_recentlyViewedDesktopCarousel__mDor3"};